import { MoreOutlined } from '@ant-design/icons';
import { Button } from '@revenuemarket/cds';
import { Dropdown } from 'antd';
interface Props {
  onToggleFold: (folded: boolean) => void;
}

const FoldToggleButton: React.FC<Props> = ({ onToggleFold }) => {
  return (
    <Dropdown
      trigger={['click']}
      menu={{
        onClick: ({ key }) => {
          if (key === 'foldAll') {
            onToggleFold(true);
          } else if (key === 'unfoldAll') {
            onToggleFold(false);
          }
        },
        items: [
          {
            label: '모든 항목 접기',
            key: 'foldAll',
          },
          {
            label: '모든 항목 펼치기',
            key: 'unfoldAll',
          },
        ],
      }}
    >
      <Button
        border
        icon={
          <MoreOutlined
            style={{
              fontSize: 18,
              transform: 'rotate(90deg)',
            }}
          />
        }
      />
    </Dropdown>
  );
};

export default FoldToggleButton;
